import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import NxtTopBar from '../../../basic/nxt-top-bar';
import IxButton from '../../../basic/ix-button';
import { blackLikeBackground } from '../../../../constants/theme-colors';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import PersonOutlineIcon from '@material-ui/icons/PersonOutline';
import { Avatar } from '@material-ui/core';
import SignInForm from './signin-form';
import { loginTakeOutOrder } from '../../home/appStateSlice';

const useStyles = makeStyles(theme => ({
  avatarWrapper: {
    color: blackLikeBackground,
    paddingTop: theme.spacing(2),
    marginTop: '2rem'
  },
  avatarContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  avatarStyle: {
    height: '80px',
    width: '80px',
    marginTop: '1rem',
    background: 'rgb(0 0 0 / 8%)'
  },
  personIcon: {
    fontSize: '2.5em',
    color: '#A6ACAF'
  },
  loginWrapper: {
    textAlign: 'center'
  },
  loginTitle: {
    fontSize: '1.7rem',
    paddingBottom: '.8rem'
  },
  loginSubTitle: {
    fontSize: '1rem',
    fontWeight: 400,
    paddingBottom: theme.spacing(4)
  },
  buttonGd: {
    marginBottom: '0.5em',
    paddingLeft: '16px',
    paddingRight: '16px',
    '& button': {
      width: '100%'
    }
  },
  btnRegistration: {
    height: '3.2em',
    color: 'black'
  }
}));

const TakeoutCustomerSignIn = props => {
  const classes = useStyles();
  const { t, i18n } = useTranslation(['common']);
  const dispatch = useDispatch();
  const history = useHistory();
  const cartItems = useSelector(state => state.cart.items);

  const handleLogin = values => {
    
    dispatch(loginTakeOutOrder({...values,history}, cartItems));
  };


  return (
    <div>
      <NxtTopBar children={t('Login')} />
      <List className={classes.avatarWrapper}>
        <ListItem className={classes.avatarContainer}>
          <Avatar className={classes.avatarStyle}>
            <PersonOutlineIcon className={classes.personIcon} />
          </Avatar>
        </ListItem>

        <ListItem className={classes.loginWrapper}>
          <ListItemText
            classes={{
              primary: classes.loginTitle,
              secondary: classes.loginSubTitle
            }}
            primary={t('loginOrReg')}
            secondary={t('loginParagraph1')}
          />
        </ListItem>
      </List>
      <SignInForm onSubmit={handleLogin} />
      <Grid
        className={classes.buttonGd}
        container
        justify='center'
        item
        direction='row'
      >
        <IxButton
          className={classes.btnRegistration}
          variant='outlined'
          color='primary'
          // disabled={
          //   editOrderedItems && editOrderedItems.length ? false : true
          // }
          onClick={() => history.push('/customer-registration')}
        >
          {t('regNewAcc')}
        </IxButton>
      </Grid>
    </div>
  );
};

export default TakeoutCustomerSignIn;
